<template>

  <div class="page-device-list">
    
	<b-card no-body>
	  <b-card-body>
	    <b-form>
		  <b-row>
		    <b-col md="4">
			  <b-form-group :label="$t('Name')">
				<b-form-input
				:placeholder="$t('Please input')+$t('Name')"
				v-model="filter.Keyword"/>  
			  </b-form-group>	  
		    </b-col>
			
			<b-col md="12">
			  <b-button
			      variant="primary"
			      class="mr-1"
				  @click="onSearch()"
			  >
			    {{$t("Search")}}
			  </b-button>
			  <b-button
			      type="reset"
			      variant="outline-secondary"
				  @click="onReset()"
			  >
				{{$t("Reset")}}
			  </b-button>
			</b-col>
		    
		  </b-row>
		</b-form>  
	  </b-card-body>
	</b-card>
	
	<b-card no-body>
		<div class="m-2">
		
		  <b-row>
		
			<!-- 添加设备 -->
		    <b-col
		      cols="12"
		      md="6"
		      class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
		    >
		      <b-button
		          variant="primary"
		          :to="{ name: 'diagnostic-device-add'}"
				  v-if="userData.role=='admin'"
		      >
		        {{$t('Add Device')}}
		      </b-button>
		    </b-col>
		
		    <!-- 筛选 -->
		    <b-col
		      cols="12"
		      md="6"
		    >
		      <div class="d-flex align-items-center justify-content-end">
		        <v-select
		          v-model="deviceStatusActive"
		          :options="deviceStatus"
		          class="filter-select"
		          :placeholder="$t('Please select device status')"
				  :reduce="dicDevStatusString => dicDevStatusString.dicDevStatusIdentifier"
				  label="dicDevStatusString"
		        >
		        </v-select>
		      </div>
		    </b-col>
		  </b-row>
		
		</div>
		
		
		<b-table
		  :items="devices"
		  responsive
		  :fields="columns"
		  show-empty
		  :empty-text="$t('No matching records found')"
		  class="position-relative"
		  sort-icon-left
		  @sort-changed="handleSortChange"
		>
		
		  <!-- 列: Name -->
		  <template #cell(deviceIdentifier)="data">
		      {{ data.item.deviceIdentifier }}
		  </template>
		  
		  <!-- 列: Platform -->
		  <template #cell(hardwarePlatform)="data">
		    {{ data.item.dicDevHwPlatform?data.item.dicDevHwPlatform.devHwPlatformString:'' }}
		  </template>
		  
		  <!-- 列: Version -->
		  <template #cell(softwareVersion)="data">
		    {{ data.item.dicDevSwVersion?data.item.dicDevSwVersion.devSwVersionString:'' }}
		  </template>
		  
		  <!-- 列: Os -->
		  <template #cell(osType)="data">
		    {{ data.item.dicDevOsType?data.item.dicDevOsType.devOsTypeString:'' }}
		  </template>
		  
		  <!-- 列: Status -->
		  <template #cell(dicDevStatus)="data">
		    {{ data.item.dicDevStatusInfo?data.item.dicDevStatusInfo.dicDevStatusString:'' }}
		  </template>
		   
		
		  <!-- 列: Actions -->
		  <template #cell(actions)="data">
		
		    <div class="text-nowrap">
			  <a
			  @click="$router.push({ name: 'diagnostic-task-list', params: { deviceName: data.item.deviceIdentifier }})"
			  >
			    <feather-icon
			    icon="SendIcon" />
			    <span class="align-middle ml-50">{{$t("Tasks")}}</span>	
			  </a>
			  
			  <a
			  v-if="userData.role=='admin'"
			  @click="$router.push({ name: 'diagnostic-device-edit', params: { name: data.item.deviceIdentifier }})"
			  >
			    <feather-icon
				class="ml-2"
			    icon="EditIcon" />
			    <span class="align-middle ml-50">{{$t("Edit")}}</span>	
			  </a>
			  
			  <a
			   v-if="userData.role=='admin'"
			   @click="onClickDel(data.index, data.item.deviceIdentifier)" >
			  	<feather-icon class="ml-2" icon="TrashIcon" />
			  	<span class="align-middle ml-50">{{$t("Delete")}}</span>
			  </a>	 
				  
		      
	
		    </div>
		  </template>
		
		</b-table>
		
		
		<div class="mx-2 mb-2">
		    <b-row>
		      <!-- 页码 -->
		      <b-col
		        cols="12"
		        sm="12"
		        class="d-flex align-items-center justify-content-center justify-content-sm-start"
		      >
		
		        <b-pagination
		          v-model="filter.Page"
		          :total-rows="total"
		          :per-page="filter.Size"
		          first-number
		          last-number
		          class="mb-0 mt-1 mt-sm-0"
		          prev-class="prev-item"
		          next-class="next-item"
				  @change="onClickPage"
		        >
		          <template #prev-text>
		            <feather-icon
		              icon="ChevronLeftIcon"
		              size="18"
		            />
		          </template>
		          <template #next-text>
		            <feather-icon
		              icon="ChevronRightIcon"
		              size="18"
		            />
		          </template>
		        </b-pagination>
		
		      </b-col>
		
		    </b-row>
		</div>
	</b-card>
	
  </div>	
	
</template>

<script>
import {
  BCard, BCardBody, BForm, BTable, BLink, BDropdown, BDropdownItem, BTooltip, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { getDeviceStatus,getDiagDevices,delDevice } from '@/api/device'
import { getUserData } from '@/utils/auth'
import { $themeConfig } from '@themeConfig'
import { getToken } from '@/utils/auth'

export default {
  components: {
    BCard,
	BCardBody,
	BForm,
	BTable,
	BLink,
	BDropdown,
	BDropdownItem,
	BTooltip,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    ToastificationContent,
	vSelect,
  },
  data() {
    return {
      //设备状态列表
      deviceStatus: [],
      //当前状态
      deviceStatusActive:null,
	  //设备总数
	  total:0,
      //设备列表
      devices:[],
      //设备列表筛选参数
      filter:{
        Page:1,
        Size:20,
		Status:null,         //设备状态
		IsDesc:null,         //是否为降序 true降序，false升序，不填默认true降序
		PropertyName:null,   //需要排序的字段
		Keyword:null,
      },
	  //选中设备
	  deviceNameList:null,
      columns: [
		{ key: 'deviceIdentifier', label: this.$t('Name'), sortable: true },
		{ key: 'hardwarePlatform', label: this.$t('Platform'), sortable: true },
		{ key: 'softwareVersion', label: this.$t('Version'), sortable: true },
		{ key: 'osType', label: this.$t('OS'), sortable: true },
		{ key: 'dicDevStatus', label: this.$t('Status'), sortable: true },
		{ key: 'actions', label: this.$t('Actions') },
      ],
      //用户信息
	  userData:{
		role:null,  
	  },
	  
	  socket: null,
	  connectionStatus: 'Disconnected'
	  
    }
  },
  created() {
    this.getDeviceStatus()
    this.getDiagDevices()
	this.userData = getUserData()
	
	this.socket = new WebSocket($themeConfig.app.socketUrl + "?token=Bearer " + getToken());
		
	// 监听 WebSocket 连接事件
	this.socket.onopen = () => {
	  this.connectionStatus = 'Connected';
	};
		
	// 监听 WebSocket 消息事件
	this.socket.onmessage = (event) => {
	  let serverData = JSON.parse(event.data);
	    if(serverData.Message=="DEVICE_UPDATE"){
		  const itemIndex = this.devices.findIndex((item) => item.deviceIdentifier === serverData.Data.deviceIdentifier);
		  if (itemIndex !== -1) {
		    this.$set(this.devices, itemIndex, serverData.Data);
		  }  
		}
	  };
	
	  // 监听 WebSocket 断开连接事件
	  this.socket.onclose = () => {
	    this.connectionStatus = 'Disconnected';
	  };
  },
  methods: {
    //获取设备状态列表列表
    getDeviceStatus(){
      getDeviceStatus().then(response => { 
		this.deviceStatus = response.data
      })
    },
    //获取设备列表列表
    getDiagDevices(){
      getDiagDevices(this.filter).then(response => {
        this.devices = response.data
		this.total = response.count
      })
    },
	//删除设备
	onClickDel(index, name){
		
		this.$bvModal
		  .msgBoxConfirm(this.$t('Please confirm will delete?'), {
		    size: 'sm',
		    okVariant: 'primary',
		    okTitle: this.$t('Confirm'),
		    cancelTitle: this.$t('Cancel'),
		    cancelVariant: 'outline-secondary',
		    hideHeaderClose: false,
		    centered: true,
		  })
		  .then(value => {
		    if(value){
			  this.devices.splice(index, 1)
			  delDevice(name).then(response => {
                this.$toast.success(this.$t('Delete Success'))
              })
				
			}
		  })
		  
	},
	//刷新页面
	freshPage(){
	  this.getDiagDevices()
	},
	//点击分页
	onClickPage(page){
	  this.filter.Page = page
	  this.freshPage()
	},
	//排序
	handleSortChange(e){
	  this.filter.PropertyName = e.sortBy
	  this.filter.IsDesc = e.sortDesc
	  this.devices = []
	  this.freshPage()
	},
	//搜索
	onSearch(){
	  this.devices = []
	  this.getDiagDevices()
	},
	//重置
	onReset(){
	  this.filter = {
	  	Page:1,
	  	Size:20,
	  	Status:null,
	  	IsDesc:null,
	  	PropertyName:null,
	  	Keyword:null,
	  }
	  this.devices = []
	  this.getDiagDevices()
	},
  },
  beforeDestroy() {
    // 断开 WebSocket 连接
  	this.socket.close();
  },
  watch: {
	//选择设备状态
    'deviceStatusActive'(newValue) {
	  this.filter.Status = newValue
      this.freshPage()
    }
  },
}
</script>
<style lang="scss" scoped>

.filter-select {
  min-width: 290px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 200px;
  }
}
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
[dir=ltr] .table.b-table > thead > tr > [aria-sort].b-table-sort-icon-left, [dir=ltr] .table.b-table > tfoot > tr > [aria-sort].b-table-sort-icon-left {
    background-position: left calc(1.72rem / 2) center;
    padding-left: calc(1.72rem + 0.65em);
}
</style>
